import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import { getColorForName } from '../../theme/colors';

// TODO: convert base Sass styles to styled-components
// TODO: create styled-compoennts styles to handle incoming props (like using theme colors)
// eslint-disable-next-line import/prefer-default-export
export const BaseFont = styled.h1`
  /* If a weight value was provided, override the default */
  ${({ weight }) => weight
    && css`
      && {
        /** TODO: would be nice to only add 1 extra specificity layer, not 2 */
        font-weight: ${weight};
      }
    `}
  /* If a align value was provided, override the default */
  ${({ align }) => align
    && css`
      && {
        text-align: ${align};
      }
    `}
  /* If a uppercase value was provided, override the default */
  ${({ uppercase }) => uppercase
    && css`
      && {
        text-transform: uppercase;
      }
    `}
  /* If a color value was provided, override the default */
  ${({ color }) => color
    && css`
      && {
        color: ${getColorForName(color)};
      }
    `}
  /* If a disableBottomPadding prop was provided, override the default */
  ${({ theme, disableBottomPadding }) => {
    if (disableBottomPadding) return '';

    return css`
      padding-bottom: ${theme.smallUp() ? rem(16) : rem(12)};
    `;
  }}
`;
